import React from 'react';
import styles from "./styles.module.less";
import { Image } from 'antd';
var Arrow = 'https://simg01.gaodunwangxiao.com/uploadimgs/tmp/upload/202410/08/7f019_20241008094222.png';
var browser = 'https://simg01.gaodunwangxiao.com/uploadimgs/tmp/upload/202410/08/5c2d0_20241008104924.png';
export var GuidePage = function GuidePage(props) {
  var visible = props.visible,
    onClose = props.onClose;
  if (!visible) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.guidePageContainer,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.guideImgContainer
  }, /*#__PURE__*/React.createElement(Image, {
    src: Arrow,
    preview: false,
    className: styles.guideArrow
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.guideArrowText
  }, /*#__PURE__*/React.createElement(Image, {
    src: browser,
    preview: false,
    className: styles.guideArrowBrowser
  }), "\u70B9\u51FB\u53F3\u4E0A\u89D2\u9009\u62E9\u6D4F\u89C8\u5668\u6253\u5F00"));
};